/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramConfigsControllerFindOneByKeyQueryResponse,
  TelegramConfigsControllerFindOneByKeyPathParams,
} from '../../types/TelegramConfigsControllerFindOneByKey.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramConfigsFindOneByKey } from '../../methods/telegramConfigsFindOneByKey.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramConfigsFindOneByKeyQueryKey = (key: TelegramConfigsControllerFindOneByKeyPathParams['key']) =>
  [{ url: '/api/telegram/configs/:key', params: { key: key } }] as const;

export type TelegramConfigsFindOneByKeyQueryKey = ReturnType<typeof telegramConfigsFindOneByKeyQueryKey>;

export function telegramConfigsFindOneByKeyQueryOptions(
  key: TelegramConfigsControllerFindOneByKeyPathParams['key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramConfigsFindOneByKeyQueryKey(key);
  return queryOptions<
    TelegramConfigsControllerFindOneByKeyQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramConfigsControllerFindOneByKeyQueryResponse,
    typeof queryKey
  >({
    enabled: !!key,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramConfigsFindOneByKey(key, config);
    },
  });
}

/**
 * {@link /api/telegram/configs/:key}
 */
export function useTelegramConfigsFindOneByKey<
  TData = TelegramConfigsControllerFindOneByKeyQueryResponse,
  TQueryData = TelegramConfigsControllerFindOneByKeyQueryResponse,
  TQueryKey extends QueryKey = TelegramConfigsFindOneByKeyQueryKey,
>(
  key: TelegramConfigsControllerFindOneByKeyPathParams['key'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramConfigsControllerFindOneByKeyQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramConfigsFindOneByKeyQueryKey(key);

  const query = useQuery(
    {
      ...telegramConfigsFindOneByKeyQueryOptions(key, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
